"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidPhotosPerPage = void 0;
exports.ValidPhotosPerPage = [0, 1, 2, 4, 6, 8, 10];
